import { useSelectedLanguageName } from '@/hooks/useSelectedLanguageName'
import { AnswerType } from '@app-studio-web/ui/types'
import QuizChoicePage from './QuizChoicePage'

const answers: AnswerType[] = [
  {
    emoji: '🥶',
    title: 'pages.quizOnboarding.struggle.answer1',
    value: 'freeze_up',
  },
  {
    emoji: '🎧',
    title: 'pages.quizOnboarding.struggle.answer2',
    value: 'understanding',
  },
  {
    emoji: '📖',
    title: 'pages.quizOnboarding.struggle.answer3',
    value: 'understand_not_speak',
  },
  {
    emoji: '😬',
    title: 'pages.quizOnboarding.struggle.answer4',
    value: 'mistakes',
  },
]

export default function StrugglePage() {
  const language = useSelectedLanguageName()

  return (
    <QuizChoicePage
      answers={answers}
      title="pages.quizOnboarding.struggle.title"
      translationInterpolation={{ language }}
    />
  )
}
